var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 42,
    height: 42,
    transform: "translate(788 94)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_50",
    "data-name": "Mask Group 50",
    transform: "translate(-788 -94)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user_15_",
    "data-name": "user (15)",
    transform: "translate(795 98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M95.107,16.15a7.813,7.813,0,0,0,5.71-2.366,7.813,7.813,0,0,0,2.366-5.71,7.815,7.815,0,0,0-2.366-5.71,8.073,8.073,0,0,0-11.419,0,7.814,7.814,0,0,0-2.366,5.709,7.813,7.813,0,0,0,2.366,5.71A7.815,7.815,0,0,0,95.107,16.15Zm0,0",
    transform: "translate(-81.332 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M27.9,256.9a19.947,19.947,0,0,0-.272-2.118,16.692,16.692,0,0,0-.521-2.13,10.521,10.521,0,0,0-.876-1.986,7.5,7.5,0,0,0-1.32-1.721,5.822,5.822,0,0,0-1.9-1.192,6.555,6.555,0,0,0-2.421-.438,2.457,2.457,0,0,0-1.312.557c-.393.257-.854.553-1.367.881a7.833,7.833,0,0,1-1.769.779,6.87,6.87,0,0,1-4.327,0,7.817,7.817,0,0,1-1.768-.779c-.509-.325-.969-.622-1.368-.882a2.454,2.454,0,0,0-1.312-.557,6.547,6.547,0,0,0-2.421.439,5.817,5.817,0,0,0-1.9,1.192,7.5,7.5,0,0,0-1.32,1.72,10.54,10.54,0,0,0-.876,1.987,16.73,16.73,0,0,0-.521,2.13A19.876,19.876,0,0,0,.067,256.9c-.045.642-.067,1.307-.067,1.98a5.567,5.567,0,0,0,1.653,4.212,5.952,5.952,0,0,0,4.261,1.554H22.058a5.951,5.951,0,0,0,4.26-1.554,5.565,5.565,0,0,0,1.654-4.212C27.972,258.207,27.949,257.541,27.9,256.9Zm0,0",
    transform: "translate(0 -231.121)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFill);
export default __webpack_public_path__ + "static/media/user-fill.a8643f17.svg";
export { ForwardRef as ReactComponent };